import React from 'react'
import { Row, Col, Form } from 'react-bootstrap';



const Authorization = ({authorizationInfo, disabled, onChange}) => {
    const isAccountItemRequired = !(authorizationInfo.account.profile || authorizationInfo.account.customer)
    const isReportItemRequired = !(authorizationInfo.report.transaction || authorizationInfo.report.registration || authorizationInfo.report.regisMonitor)
    return (
        <React.Fragment>
            <Row>
                <Col sm={12} className="text-grey font-weight-bold">
                    User Authorization
                </Col>
            </Row>
            <Row className="mt-3 ml-3 mr-3 pb-3 border-bottom">
                <Col>
                    <Row>
                    <Form.Check
                        custom inline label="Account" name="account" id="account"
                        checked={authorizationInfo.account.value}
                        onChange={(e) => onChange("account", "value", e.target.checked)}
                        disabled={disabled}
                    />
                    </Row>
                    <Row className="mt-1 ml-3">
                        <Col className="mt-2" sm={6}>
                            <Form.Check
                            custom inline label="Profile" name="profile" id="profile"
                            checked={authorizationInfo.account.profile}
                            onChange={(e) => onChange("account", e.target.name, e.target.checked)}
                            disabled={disabled || !authorizationInfo.account.value}
                            required={isAccountItemRequired}  
                            />
                        </Col>
                        <Col className="mt-2" sm={6}>
                            <Form.Check
                            custom inline label="Customer" name="customer" id="customer"
                            checked={authorizationInfo.account.customer}
                            onChange={(e) => onChange("account", e.target.name, e.target.checked)}
                            disabled={disabled || !authorizationInfo.account.value}
                            required={isAccountItemRequired}                             
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className="mt-3 ml-3 mr-3 pb-3 border-bottom">
                <Col>
                    <Row>
                    <Form.Check
                        custom inline label="Report" name="report" id="report"
                        checked={authorizationInfo.report.value}
                        onChange={(e) => onChange("report", "value", e.target.checked)}
                        disabled={disabled}
                    />
                    </Row>
                    <Row className="mt-1 ml-3">
                        <Col className="mt-2" sm={6}>
                            <Form.Check
                            custom inline label="Transaction" name="transaction" id="transaction"
                            checked={authorizationInfo.report.transaction}
                            onChange={(e) => onChange("report", e.target.name, e.target.checked)}
                            disabled={disabled || !authorizationInfo.report.value}
                            required={isReportItemRequired}  
                            />
                        </Col>
                        {/* <Col className="mt-2" sm={6}>
                            <Form.Check
                            custom inline label="Scheduled Transaction" name="schdTransaction" id="schdTransaction"
                            checked={authorizationInfo.report.schdTransaction}
                            onChange={(e) => onChange("report", e.target.name, e.target.checked)}
                            disabled={disabled || !authorizationInfo.report.value}
                            required={isReportItemRequired}  
                            />
                        </Col> */}
                        <Col className="mt-2" sm={6}>
                            <Form.Check
                            custom inline label="Registration" name="registration" id="registration"
                            checked={authorizationInfo.report.registration}
                            onChange={(e) => onChange("report", e.target.name, e.target.checked)}
                            disabled={disabled || !authorizationInfo.report.value}
                            required={isReportItemRequired}  
                            />
                        </Col>
                        <Col className="mt-2" sm={6}>
                            <Form.Check
                            custom inline label="Online Registration Monitoring" name="regisMonitor" id="regisMonitor"
                            checked={authorizationInfo.report.regisMonitor}
                            onChange={(e) => onChange("report", e.target.name, e.target.checked)}
                            disabled={disabled || !authorizationInfo.report.value}
                            required={isReportItemRequired}  
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default Authorization
